import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentOriginators } from './normalize';

export const fetchShipmentOriginators = createProvider(api.fetchShipmentOriginators)
  .andThen((res) => normalizeShipmentOriginators(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
